import { getSearchParams } from "../../../utils/request";
import { api } from "../../api";

const tagsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getTags: builder.query({
      query: ({ page = 1, limit = 100, appliesTo, ...rest } = {}) => {
        const query = getSearchParams({
          page,
          limit,
          ...(appliesTo ? { appliesTo } : {}),
          ...rest,
        });
        return `tags?${query}`;
      },
      providesTags: (data) =>
        data?.tags
          ? [
              ...data.tags.map(({ _id }) => ({ type: "Tags", id: _id })),
              { type: "Tags", id: "LIST" },
            ]
          : [{ type: "Tags", id: "LIST" }],
    }),
    addTag: builder.mutation({
      query: (body) => ({
        url: "tags",
        method: "POST",
        body,
      }),
      invalidatesTags: [
        { type: "Tags", id: "LIST" },
        { type: "InvoicesV2", id: "LIST" },
      ],
    }),
    updateTag: builder.mutation({
      query: ({ id, data }) => ({
        url: `tags/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: "Tags", id },
        { type: "Tags", id: "LIST" },
        { type: "Jobs", id: "LIST" },
        { type: "InvoicesV2", id: "LIST" },
      ],
    }),
    archiveTag: builder.mutation({
      query: (id) => ({
        url: `tags/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: (_result, _error, id) => [
        { type: "Tags", id },
        { type: "Tags", id: "LIST" },
        { type: "Jobs", id: "LIST" },
        { type: "InvoicesV2", id: "LIST" },
      ],
    }),
    restoreTag: builder.mutation({
      query: (id) => ({
        url: `tags/${id}/restore`,
        method: "PUT",
      }),
      invalidatesTags: (_result, _error, id) => [
        { type: "Tags", id },
        { type: "Tags", id: "LIST" },
        { type: "Jobs", id: "LIST" },
        { type: "InvoicesV2", id: "LIST" },
      ],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetTagsQuery,
  useAddTagMutation,
  useUpdateTagMutation,
  useArchiveTagMutation,
  useRestoreTagMutation,
} = tagsApi;

export default tagsApi;
